exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".title-login[data-v-71aa28fd]{font-size:1.2rem;font-weight:500;color:#235ba6;margin-bottom:.5rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-71aa28fd&scoped=true!./~/sass-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./app/components/Login.vue
// module id = 225
// module chunks = 0